// extracted by mini-css-extract-plugin
module.exports = {"activeIconColor":"#00acac","menuColorHover":"#fff","menuBg":"#2d353c","menuText":"#a8acb1","menuActiveText":"#fff"};